<template lang="html">
  <modal
    name="edit-city-page-modal"
    height="auto" width="1000" :adaptive="true"
    class="edit-city-page-modal"
    @before-open="beforeOpen"
  >
    <FullScreenProgress :progress="progress" :max="100" />
    <div class="modal-container">
      <div class="modal-header">
        {{headerText}}
        <SymbiumButton
          v-if="$article.shouldHaveProductionPublishLink()"
          text="Publish To Production"
          :onClick="publishToProduction"
          :loading="loading"
          :isSmall="true"
        />
      </div>
      <div class="line-break" />
      <div class="modal-body">
        <div class="bold">City Name</div>
        <div class="gap-1x"></div>
        <input v-model="article.subject" placeholder="City Name" />
        <div class="gap-3x"></div>
        <SymbiumButton
          text="Add Statistics Section"
          :onClick="addStatisticsSection"
          kclass="margin-right-2x"
          :isSmall="true"
        />
        <SymbiumButton
          text="Remove Statistics Section"
          :onClick="removeStatisticsSection"
          :isSmall="true"
        />
        <div v-if="article.data.statisticsSections">
          <div v-for="(statisticsSection, index) in article.data.statisticsSections" :key="statisticsSection.highlight">
            <div class="gap-4x" />
            <div class="bold">Section #{{index + 1}}</div>
            <input :value="statisticsSection.highlight" @change="(event) => { statisticsSection.highlight = event.target.value }" :name="`highlight${index}`" placeholder="Highlight"/>
            <div class="gap-1x" />
            <input :value="statisticsSection.description" @change="(event) => { statisticsSection.description = event.target.value }" :name="`description${index}`" placeholder="description"/>
          </div>
        </div>
        <div class="gap-3x" />
        <div class="bold med-text">
          Cover Image
        </div>
        <img :src="article.data.coverURL" height="300" v-if="article.data.coverURL" />
        <div class="gap-2x" />
        <vue2Dropzone
          :awss3="awss3"
          id="image-upload"
          v-on:vdropzone-s3-upload-success="s3UploadSuccess"
          v-on:vdropzone-file-added="startDisplayProgressBar"
          @vdropzone-upload-progress="updateProgress"
          :options="dropzoneOptions"
          :include-styling="false"
          :useCustomSlot="true"
        >
          <SymbiumButton
            text="Add Image"
            :isSmall="true"
          />
        </vue2Dropzone>
        <div class="gap-2x" />
        <div class="bold">Cover Caption</div>
        <div class="gap-1x" />
        <div class="cover-caption-editor">
          <ckeditor :editor="editor" v-model="article.data.coverCaption" :config="editorConfig" />
        </div>
        <div class="gap-3x" />
        <div class="bold med-text">
          Main Content
        </div>
        <ckeditor :editor="editor" v-model="article.content_html" :config="editorConfig" />
        <div class="gap-3x" />
        <SymbiumButton
          v-if="article.id"
          text="Delete this city page"
          :onClick="emitDestroy"
          :isSmall="true"
          :isPrimary="true"
        />
        <div class="gap-3x" />
      </div>
      <div class="line-break" />
      <ModalFooter
        :save="save"
        :cancel="() => $modal.hide('edit-city-page-modal')"
        :rightActionLoading="loading"
      />
    </div>
  </modal>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import CKEditor from '@ckeditor/ckeditor5-vue2';

import ModalFooter from 'src/components/common/modals/shares/ModalFooter.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import DisableBodyScroll from 'src/mixins/DisableBodyScroll.js'
import FileUploadProgress from 'src/mixins/FileUploadProgress.js'
import FullScreenProgress from 'src/components/common/FullScreenProgress.vue'

import EditArticle from '../mixins/EditArticle.js'

export default {
  components: {
    ModalFooter, vue2Dropzone, FullScreenProgress,
    ckeditor: CKEditor.component, SymbiumButton
  },
  mixins: [DisableBodyScroll, FileUploadProgress, EditArticle],
  methods: {
    addStatisticsSection() {
      this.article.data.statisticsSections = this.article.data.statisticsSections || []
      this.article.data.statisticsSections.push({ highlight: null, description: null})
      this.$nextTick(function() {
        this.$forceUpdate()
      })
    },
    removeStatisticsSection() {
      if(!this.article.data.statisticsSections) return
      this.article.data.statisticsSections.pop()
      this.$nextTick(function() {
        this.$forceUpdate()
      })
    },
  },
  computed: {
    headerText() {
      return this.article.id ? `Edit City Page` : 'New City Page'
    },
  }
}
</script>

<style lang="scss">
.modal-body {
  input, select {
    width: 100%;
  }
}

.edit-city-page-modal {
  .modal-body {
    max-height: calc(100vh - 192px) !important;
  }
}

.ck-balloon-panel{
  z-index: 999999 !important;
}
</style>
